import i18next from 'i18next'
import translations from './translations.json'
import { Language, DEFAULT_LANGUAGE } from './globals'

export const initializeTranslations = async (requestedLang: Language) => {
  await i18next.init({
    lng: requestedLang,
    fallbackLng: DEFAULT_LANGUAGE,
    resources: translations,
  })
}